"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgSearch = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 25 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M17.616 15.09l6.529 6.53c.488.488.488 1.279 0 1.767-.492.48-1.276.48-1.768 0l-6.53-6.529a9.284 9.284 0 111.769-1.768zM10.26 2.75A6.75 6.75 0 003.51 9.5a6.758 6.758 0 006.75 6.75 6.75 6.75 0 000-13.5z", clipRule: "evenodd" })));
};
exports.default = SvgSearch;
//# sourceMappingURL=Search.js.map